import React from 'react';
import { Box, CircularProgress, Typography, Container, useTheme } from '@mui/material';
import regenaiLogo from '../../assets/regenai-logo.png';

const AuthenticationLoading: React.FC = () => {
  const theme = useTheme();

  return (
    <Container
      maxWidth={false}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          gap: 3,
          padding: 4,
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
          animation: 'fadeIn 0.5s ease-in-out',
          '@keyframes fadeIn': {
            '0%': {
              opacity: 0,
              transform: 'translateY(20px)'
            },
            '100%': {
              opacity: 1,
              transform: 'translateY(0)'
            },
          },
        }}
      >
        <img 
          src={regenaiLogo} 
          alt="RegenAI Logo" 
          style={{ width: '50px', height: 'auto' }} 
        />
        
        <Typography variant="h5" fontWeight={600} color="primary" gutterBottom>
          RegenAI
        </Typography>
        
        <CircularProgress 
          size={48} 
          thickness={4} 
          sx={{ 
            color: '#8A4DD0',
            animation: 'pulse 1.5s ease-in-out infinite',
            '@keyframes pulse': {
              '0%': {
                transform: 'scale(0.95)',
                opacity: 0.7,
              },
              '50%': {
                transform: 'scale(1.05)',
                opacity: 1,
              },
              '100%': {
                transform: 'scale(0.95)',
                opacity: 0.7,
              },
            },
          }} 
        />
        
        <Typography variant="body1" color="text.secondary" align="center">
          Authenticating your account...
        </Typography>
      </Box>
    </Container>
  );
};

export default AuthenticationLoading; 